// extracted by mini-css-extract-plugin
module.exports = {"wm84dxr":"wm84dxr","l1ugbgq":"l1ugbgq"};